import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { dynamicBaseQuery } from '~/api/common/dynamicBaseQuery';
import { PageCampaignHistory } from '~/api/models/page-campaign-history';
import { CampaignHistorySearchCriteria } from '~/api/models/campaign-history-search-criteria';

export const campaignHistoryServiceApi = createApi({
    reducerPath: 'campaignHistoryApi',
    baseQuery: dynamicBaseQuery,
    tagTypes: ['CampaignHistory'],
    endpoints: (builder) => ({
        searchCampaignHistory: builder.query<PageCampaignHistory, CampaignHistorySearchCriteria>(
            {
                query: ({ page, size, campaignId, ...filters }) => ({
                    url: '/v1/admin/campaign-history/search',
                    method: 'POST',
                    body: { campaignId, ...filters },
                    params: { page, size },
                }),
                providesTags: ['CampaignHistory'],
            }
        ),
    }),
});

export const { useSearchCampaignHistoryQuery } = campaignHistoryServiceApi;
